import { SendRequest } from '../wcl-helpers.js';

const generatePDFLinks = document.querySelectorAll('.js-generate-pdf-link');
const documentsWrapper = document.querySelector('.wcl-myaccount-wrapper');

if (generatePDFLinks.length > 0) {
    generatePDFLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            const pdfType = link.dataset.fileType;

            documentsWrapper.classList.add('loading');

            // Prepare data to request
            const requestArgs = `&pdf_type=${encodeURIComponent(pdfType)}`;

            SendRequest('generate_pdf', requestArgs).then(function (res) {
                documentsWrapper.classList.remove('loading');

                let response = JSON.parse(res);

                if (response.success == '1') {
                    const downloadLink = document.createElement('a');

                    downloadLink.id = 'download_pdf_link';
                    downloadLink.href = 'data:application/pdf;base64,' + response.pdf_content;
                    downloadLink.download = 'pdf_' + response.user_last_name + '.pdf';
                    document.body.appendChild(downloadLink);
                    downloadLink.click();

                } else {

                    if (response.notice_markup) {
                        const noticesWrapper = document.querySelector('.woocommerce-notices-wrapper');

                        if (noticesWrapper) {
                            noticesWrapper.innerHTML = response.notice_markup;
                        }
                    } else {
                        throw new Error(response.message);
                    }

                }

            }).catch(function (err) {
                // Error
                console.error(err);
                documentsWrapper.classList.remove('loading');
            });
        });
    });
}